export default __webpack_public_path__ + "static/media/etc.c4891d54.png";